import {remCalc} from '../../_utils'
export default {
    baseStyle: {
        linkModule: {
            width: '100%',
            py: remCalc(28),
            flexDirection: 'column',
            gap: remCalc(16),
            padding: {base: `${remCalc(32)} 0`, lg: remCalc(24)},
            layerStyle: 'full',
        },
        linkModuleTitle: {
            fontSize: {base: remCalc(22), lg: remCalc(24)},
            fontWeight: 'medium',
            textAlign: 'center',
        },
        linkModuleContainer: {
            flexDirection: {base: 'column', lg: 'row'},
            gap: {base: remCalc(42), lg: remCalc(24)},
            flexWrap: {lg: 'wrap'},
            justifyContent: {lg: 'center'},
        },
        linkModuleIconContainer: {
            gap: {base: remCalc(16), lg: remCalc(21)},
            alignItems: {base: 'center'},
        },
        linkModuleIcon: {
            width: {base: remCalc(32)},
            height: {base: remCalc(32)},
            color: 'text.secondary',
        },
        linkModuleText: {
            fontSize: remCalc(18),
            color: 'text.secondary',
            alignSelf: 'center',
        },
    },
}
